import { createContext, useContext } from 'react'
import { TRootStore } from './RootStore'

const RootStoreContext = createContext<TRootStore>({} as TRootStore)

export const RootStoreProvider = RootStoreContext.Provider

export const useStores = (): TRootStore => useContext(RootStoreContext)
